import React from "react";

const HomeIcon_NavItem = () => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3743_52)">
        <path
          d="M10.7792 10.3125H0.466675V2.8125C0.466675 2.06658 0.762991 1.35121 1.29044 0.823762C1.81788 0.296316 2.53325 0 3.27917 0L10.7792 0V10.3125ZM2.34167 8.4375H8.90417V1.875H3.27917C3.03053 1.875 2.79208 1.97377 2.61626 2.14959C2.44045 2.3254 2.34167 2.56386 2.34167 2.8125V8.4375Z"
          fill="black"
        />
        <path
          d="M22.9667 10.3125H12.6542V0H20.1542C20.9001 0 21.6155 0.296316 22.1429 0.823762C22.6704 1.35121 22.9667 2.06658 22.9667 2.8125V10.3125ZM14.5292 8.4375H21.0917V2.8125C21.0917 2.56386 20.9929 2.3254 20.8171 2.14959C20.6413 1.97377 20.4028 1.875 20.1542 1.875H14.5292V8.4375Z"
          fill="black"
        />
        <path
          d="M10.7792 22.5H3.27917C2.53325 22.5 1.81788 22.2037 1.29044 21.6762C0.762991 21.1488 0.466675 20.4334 0.466675 19.6875L0.466675 12.1875H10.7792V22.5ZM2.34167 14.0625V19.6875C2.34167 19.9361 2.44045 20.1746 2.61626 20.3504C2.79208 20.5262 3.03053 20.625 3.27917 20.625H8.90417V14.0625H2.34167Z"
          fill="black"
        />
        <path
          d="M20.1542 22.5H12.6542V12.1875H22.9667V19.6875C22.9667 20.4334 22.6704 21.1488 22.1429 21.6762C21.6155 22.2037 20.9001 22.5 20.1542 22.5ZM14.5292 20.625H20.1542C20.4028 20.625 20.6413 20.5262 20.8171 20.3504C20.9929 20.1746 21.0917 19.9361 21.0917 19.6875V14.0625H14.5292V20.625Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_3743_52">
          <rect
            width="22.5"
            height="22.5"
            fill="white"
            transform="translate(0.466675)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HomeIcon_NavItem;
